import type { FaireProductEntity } from "../../entity_types/product";

export const p_ujffjx3nz7: FaireProductEntity = {
  token: "p_ujffjx3nz7",
  type: "product",
  name: "Beer Cheers Anniversary Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/8587c71caec7f1ae963bb8ac9d87363c411a41e8858ab23d0eeec32bca4403ab.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ffa0e20178710090d95623d7b7ce1579a5ba092f71e38d3ffc0394e68e84d38f.jpeg",
    "https://cdn.faire.com/fastly/46028691c7db88a5391ef7ca383d4264ec0458353a605834a81dd73c775175af.jpeg",
  ],
  priceDollars: 3,
  description:
    "Our Beer Cheers Anniversary Greeting Card by E. Frances Paper is designed to bring joy and laughter to your special occasions. With our unique, humorous, and nostalgic illustrations, we aim to make each greeting card a memorable keepsake. This card, featuring a 'NORM!' message, is perfect for celebrating anniversaries. Based in Newport, RI, our team takes great joy in knowing that our cards bring happiness to recipients everywhere. Celebrate your anniversaries with a cheerful toast!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:54.051Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
